import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useSubmitButton } from './hooks/useSubmitButton';

export const SubmitButton: React.FC = () => {
	const {
		data: { hideSubmit },
	} = useSubmitButton();

	if (hideSubmit) {
		return null;
	}

	return (
		<Button type="submit" variant="primary" data-qa="report-abuse-submit-button">
			<Translate value="corgi.policy_abuse.generic.form_submit" />
		</Button>
	);
};
